import script from "./ChatBodyPostsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBodyPostsItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__